module.exports = "<div id=modal-delete class=modal-header> <h3>{{:: T.DELETE }}</h3> </div> <div class=modal-body> <h3>{{:: T.SURE_TO_DELETE }}</h3> </div> <div class=modal-footer> <button type=button class=\"sw-btn sw-btn-default\" ng-click=$dismiss()>{{:: T.CANCEL }}</button> <button type=button class=\"sw-btn sw-btn-danger\" ng-click=$close()>{{:: T.DELETE }}</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app.modal/confirmDeleteModal.html
// module id = 155
// module chunks = 0